export const STONE_BANNER = {
  developerId: 7229,
};

/** Регионы показа баннера СТОУН — Москва и МО */
export const STONE_REGIONS = [1, 4593];
